/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlamiIntegrationData
 */
export interface GlamiIntegrationData {
    /**
     * 
     * @type {string}
     * @memberof GlamiIntegrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GlamiIntegrationData
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof GlamiIntegrationData
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof GlamiIntegrationData
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GlamiIntegrationData
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GlamiIntegrationData
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlamiIntegrationData
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GlamiIntegrationData
     */
    lastHistoricalUpdate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GlamiIntegrationData
     */
    paused?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlamiIntegrationData
     */
    project?: string;
}

/**
 * Check if a given object implements the GlamiIntegrationData interface.
 */
export function instanceOfGlamiIntegrationData(value: object): value is GlamiIntegrationData {
    return true;
}

export function GlamiIntegrationDataFromJSON(json: any): GlamiIntegrationData {
    return GlamiIntegrationDataFromJSONTyped(json, false);
}

export function GlamiIntegrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlamiIntegrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] === undefined ? undefined : json['lastRegularUpdate'] === null ? null : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] === undefined ? undefined : json['lastHistoricalUpdate'] === null ? null : json['lastHistoricalUpdate'],
        'paused': json['paused'] == null ? undefined : json['paused'],
        'project': json['project'] == null ? undefined : json['project'],
    };
}

export function GlamiIntegrationDataToJSON(json: any): GlamiIntegrationData {
    return GlamiIntegrationDataToJSONTyped(json, false);
}

export function GlamiIntegrationDataToJSONTyped(value?: GlamiIntegrationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
        'paused': value['paused'],
        'project': value['project'],
    };
}

